import dayjs from "dayjs";

export const paymentHistoryConverter = (data, itemsOnPage) => {
  const {
    isSuccess,
    isTimeIsUp,
    dateFrom,
    dateTo,
    page,
  } = data;

  let status = undefined;

  switch (true) {
    case isSuccess && !isTimeIsUp:
      status = 1;
      break;
    case !isSuccess && isTimeIsUp:
      status = 3;
      break;
    case !isSuccess && !isTimeIsUp:
      status = 0;
      break;
    default: status = undefined;
  }

  return {
    skip: page * itemsOnPage,
    limit: itemsOnPage,
    status,
    valid_until_gte: dayjs(dateFrom).format('YYYY-MM-DDTHH:mm:ss.000000'),
    valid_until_lte: dayjs(dateTo).format('YYYY-MM-DDTHH:mm:ss.000000'),
  };
};
